import { v4 } from "uuid";
import {
  ColumnDescriptor,
  Gate,
  Relation,
  RelationType,
  ValueShape,
  WhereItem,
} from "src/globalTypes";
import { AggregationGroup, AggregationItem } from "../templateBuilder";
import { createColumnDescriptor } from "../../../utils";

export const aggregationGroupPLACEHOLDER: AggregationGroup = {
  id: 0,
  name: "",
  type: "sum",
  itemList: [],
};

export const aggregationItemPLACEHOLDER: AggregationItem = {
  itemId: null,
  itemType: "static",
  staticValue: "",
};

export const whereItemSourcePLACEHOLDER: ColumnDescriptor =
  createColumnDescriptor({
    columnIdentifier: "0",
  });

export const whereItemRelationPLACEHOLDER: Relation = {
  type: RelationType.TextValue,
  operator: "eq",
};

export const whereItemSearchValuePLACEHOLDER: ValueShape = {
  numberVal: null,
  stringVal: null,
  booleanVal: null,
  dateVal: null,
  dateValDynamic: null,
  dateValRange: null,
  targetColumnVal: null,
  selectVal: null,
};

export const whereItemPLACEHOLDER: WhereItem = {
  source: whereItemSourcePLACEHOLDER,
  relation: whereItemRelationPLACEHOLDER,
  searchValue: whereItemSearchValuePLACEHOLDER,
  children: [],
  gate: Gate.And,
  disabled: false,
  isList: false,
  id: v4(),
};
